/**
 * Agent Transition Graph (FAQ-only)
 *
 * Defines which agents are likely to be transitioned to from each agent.
 * Used for pre-warming connections to reduce transition latency.
 */

export const AGENT_TRANSITION_GRAPH: Record<string, string[]> = {
  'greeting_agent': ['welcome_agent'],
  'welcome_agent': ['faq_agent'],
  'faq_agent': ['welcome_agent'],
};

/**
 * Get the list of likely next agents for a given agent.
 */
export function getLikelyNextAgents(currentAgentId: string): string[] {
  return AGENT_TRANSITION_GRAPH[currentAgentId] || [];
}

/**
 * Check if an agent has likely next agents defined.
 */
export function hasPrewarmTargets(agentId: string): boolean {
  const targets = AGENT_TRANSITION_GRAPH[agentId];
  return targets !== undefined && targets.length > 0;
}

/**
 * Get all unique agent IDs from the transition graph.
 */
export function getAllAgentsInGraph(): string[] {
  const allAgents = new Set<string>();
  Object.keys(AGENT_TRANSITION_GRAPH).forEach((agent) => allAgents.add(agent));
  Object.values(AGENT_TRANSITION_GRAPH).forEach((targets) => {
    targets.forEach((target) => allAgents.add(target));
  });
  return Array.from(allAgents);
}
